import React, { createRef, useEffect, useReducer } from "react";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { inputStyles } from "../styles/styles";
import BaseWindow from "./public/BaseWindow";
import { getNextStep, getProductTypeString } from "../utils/enums.ts";
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Checkbox,
  Button,
  Box,
  FormGroup,
  FormControlLabel,
} from "@material-ui/core";
import DocumentDialog from "./DocumentDailog";
import { connect } from "react-redux";
import { updateAlert } from "../store/alert/actions";
import { bindActionCreators } from "redux";
import {
  getDocuments,
  saveDocuments,
  used,
} from "../store/document/thunkActions";
import {
  getDocumentName,
  getErrorMessage,
  getPreviousStep,
} from "../utils/enums";
import { updateUnsuccessMsg } from "../store/unsuccess/actions";
import InfoIcon from "@material-ui/icons/Info";
import {
  addProcessContext,
  clearProcessContext,
} from "../store/processContext/actions";
import NotFoundPage from "./public/NotFoundPage";
import BaseTextField from "./public/BaseTextField";
import { otpMask } from "./public/TextMask";
import CountDown from "./public/CountDown";
import { generateOTP, generateOtpEasycep } from "../store/global/thunkActions";
import { updateLoading } from "../store/loading/actions";

const documentsArrBasvuru = [
  "Bankacılık İşlemleri Komisyon ve Ücret Bilgi Formu",
  "İhtiyaç Kredisi Sözleşme Öncesi Bilgi Formu",
  "İhtiyaç Kredisi Başvuru Formu Dijital..",
];
const documentsArrKullandirim = [
  "Ödeme Planı",
  "Kiraz Hesap Ürün Bilgi ve Başvuru Formu",
  "Tüketici Kredi Sözleşmesi",
  "Virman Talimatı",
];

const normalizeShopUrl = (url) => {
  if (!url || typeof url !== "string") return url;
  const trimmed = url.trim();
  if (/^[a-zA-Z][a-zA-Z0-9+\-.]*:\/\//.test(trimmed)) return trimmed;
  return "https://" + trimmed;
};

function Documents(props) {
  const classes = inputStyles();
  const pageName = "documents";
  let history = useHistory();
  let { uuid } = useParams();

  const [checked, setChecked] = React.useState([]);
  const [canChecked, setCanChecked] = React.useState([]);
  const [otpCode, setOtpCode] = React.useState("");
  const [sendMailForDocument, setSendMailForDocument] = React.useState(false);
  const [smsSended, setSmsSended] = React.useState(false);
  const otpTryCount = React.useRef(0);

  const [time, setTime] = React.useState(60);
  const [timer, setTimer] = React.useState();

  const [isUsedInProgress, setIsUsedInProgress] = React.useState(false);

  useEffect(() => {
    if (props.processContext.stepName === pageName) {
      props.actions.getDocuments({
        externalId: uuid,
        criterList: props.processContext.criterList,
        interestRateId: props.processContext.interestRateId,
        installmentNumber: props.processContext.installmentNumber,
        kvkkFlag: props.processContext.kvkkFlag,
      });
    }
  }, []);

  const startTimer = () => {
    const timer = setInterval(() => {
      setTime((prevState) => {
        if (prevState <= 1) {
          stopTimer();
          return 0;
        } else {
          return prevState - 1;
        }
      });
    }, 1000);

    setTimer(timer);
  };
  const stopTimer = () => {
    setTimer((prevState) => {
      clearInterval(prevState);
      return null;
    });
  };

  const handleCheck = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    }
    setChecked(newChecked);
  };

  const sendSms = () => {
    if (props.document.documents?.length !== checked.length) {
      props.actions.updateAlert({
        severity: "error",
        text: getErrorMessage("MS0017"),
        open: true,
      });
    } else {
      if (props.processContext.companyCode === "EASYCEPT") {
        let body = {
          nationalIdentityNo: props.customerInformations.tckn,
          taxNumber: props.customerInformations.taxNo,
          validateMobileNumber: "1",
          otpType: "SMS",
          externalId: uuid,
          companyCode: props.processContext.companyCode,
          agencyCode: props.processContext.agencyCode,
          productType: props.processContext.productType,
          mobileNumber:
            props.customerInformations.phoneNumber?.length === 10
              ? props.customerInformations.phoneNumber
              : "",
        };

        //setOtpModalOpen(true);

        props.actions.generateOtpEasycep(body).then((res) => {
          setSmsSended(true);
          if (
            props.global.otpInfo?.expireSecond &&
            props.global.otpInfo.expireSecond !== ""
          ) {
            setTime(parseInt(props.global.otpInfo.expireSecond));
            startTimer();
          }
        });
      } else {
        props.actions
          .generateOTP({
            nationalIdentityNo: props.customerInformations.tckn,
            otpType: "SMS",
            mobileNumber: props.customerInformations.phoneNumber,
            externalId: uuid,
          })
          .then(() => {
            setSmsSended(true);
            if (
              props.global.otpInfo?.expireSecond &&
              props.global.otpInfo.expireSecond !== ""
            ) {
              setTime(parseInt(props.global.otpInfo.expireSecond));
              startTimer();
            }
          });
      }
    }
  };

  const devamClick = () => {
    if (isUsedInProgress) return; //yeni
    setIsUsedInProgress(true); //yeni
    if (props.global.otpInfo.pushDelivery !== "1" && otpCode.length !== 6) {
      props.actions.updateAlert({
        severity: "error",
        text: "SMS Doğrulama Kodunu Giriniz!",
        open: true,
      });
      setIsUsedInProgress(false);
      return;
    }

    if (props.document?.documents?.length !== checked.length) {
      props.actions.updateAlert({
        severity: "error",
        text: getErrorMessage("MS0017"),
        open: true,
      });
    } else {
      props.actions
        .used({
          externalId: uuid,
          otpOID: props.global.otpInfo.otpOID,
          otpReference: props.global.otpInfo.otpReference,
          otpKey: otpCode,
          identityNo: props.customerInformations.tckn,
          sendMailForDocument: sendMailForDocument ? "1" : "0",
        })
        .then((res) => {
          if (res.result === "1") {
            setIsUsedInProgress(false);
            if (res?.shopUrl) {
              window.location.href =
                normalizeShopUrl(res?.shopUrl?.split(";")[0]) +
                  "?orderId=" +
                  res?.orderReferenceNo;
              props.actions.clearProcessContext();
            } else {
              props.actions.addProcessContext({ used: res });
              props.actions.updateLoading(false);
              let nextStepName = getNextStep(pageName);
              props.actions.addProcessContext({ stepName: nextStepName });
              history.push(nextStepName);
            }
            setIsUsedInProgress(false); //yeni
          } else if (res.result === "2") {
            props.actions.addProcessContext({
              usedWithBatch: res.result,
            });
            if (res?.shopUrl?.split(";").length === 3) {
              window.location.href =
                normalizeShopUrl(res?.shopUrl?.split(";")[2]) +
                  "?orderId=" +
                  res?.orderReferenceNo;
              props.actions.clearProcessContext();
            } else {
              props.actions.updateLoading(false);
              let nextStepName = getNextStep(pageName);
              props.actions.addProcessContext({ stepName: nextStepName });
              history.push(nextStepName);
            }
            setIsUsedInProgress(false); //yeni
          } else {
            if (res?.errorCode === "4007763") {
              otpTryCount.current += 1;
              if (otpTryCount.current > 3) {
                if (res?.shopUrl) {
                  window.location.href =
                    normalizeShopUrl(res?.shopUrl?.split(";")[1]) +
                      "?orderId=" +
                      res?.orderReferenceNo;

                  props.actions.clearProcessContext();
                  setIsUsedInProgress(false); //yeni
                } else {
                  props.actions.updateUnsuccessMsg(
                    getErrorMessage("MS0033")
                      ? getErrorMessage("MS0033")
                      : "İşlem sırasında hata meydana gelmiştir. Lütfen daha sonra tekrar deneyiniz.",
                  );
                  props.actions.addProcessContext({ used: res });
                  props.actions.updateLoading(false);

                  let nextStepName = "unsuccess";
                  props.actions.addProcessContext({ stepName: nextStepName });
                  history.push(nextStepName);
                }
              } else {
                props.actions.updateAlert({
                  severity: "error",
                  text: res?.errorText,
                  open: true,
                });
                props.actions.updateLoading(false);
                setIsUsedInProgress(false); //yeni
              }
            } else {
              if (res?.shopUrl) {
                window.location.href =
                  normalizeShopUrl(res?.shopUrl?.split(";")[1]) +
                    "?orderId=" +
                    res?.orderReferenceNo;

                props.actions.clearProcessContext();
                setIsUsedInProgress(false); //yeni
              } else {
                props.actions.updateUnsuccessMsg(
                  getErrorMessage("MS0033")
                    ? getErrorMessage("MS0033")
                    : "İşlem sırasında hata meydana gelmiştir. Lütfen daha sonra tekrar deneyiniz.",
                );
                props.actions.addProcessContext({ used: res });
                props.actions.updateLoading(false);

                let nextStepName = "unsuccess";
                props.actions.addProcessContext({ stepName: nextStepName });
                history.push(nextStepName);
              }
            }
          }
        })
        .catch((err) => {
          props.actions.updateAlert({
            severity: "error",
            text: "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyiniz.",
            open: true,
          });
          props.actions.updateLoading(false);
          setIsUsedInProgress(false); //yeni
        });
    }
  };

  const geriClick = () => {
    let prevStepName = getPreviousStep(pageName);
    if (!props.processContext.kvkkDocument) {
      prevStepName = getPreviousStep(prevStepName);
    }
    props.actions.addProcessContext({ stepName: prevStepName });
    history.push(prevStepName);
  };

  return props.processContext.stepName !== pageName ? (
    <></>
  ) : (
    <BaseWindow isBasket={true}>
      <Grid item xs={8}>
        <List className={classes.root}>
          <p className={classes.p}> Kullandırım Dokümanları</p>
          {props.document?.documents?.map((value, index) => {
            const labelId = `checkbox-list-label-${value.documentCode}`;
            let tempRef = createRef();
            return (
              <ListItem key={value.documentCode} role={undefined} dense>
                <ListItemIcon style={{ minWidth: 0, height: "21px" }}>
                  <Checkbox
                    required
                    edge="start"
                    checked={checked.indexOf(value.documentCode) !== -1}
                    disabled={checked.indexOf(value.documentCode) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                    onClick={() => {
                      tempRef.current.click();
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  id={labelId}
                  primary={value.documentName}
                  classes={{
                    primary: classes.label,
                  }}
                />
                <ListItemSecondaryAction>
                  <DocumentDialog
                    buttonRef={tempRef}
                    title={value.documentCode}
                    document={value}
                    handleCheck={handleCheck}
                    uuid={uuid}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      </Grid>
      <div style={{ display: "flex", marginTop: 15, marginBottom: 15 }}>
        <InfoIcon
          fontSize="small"
          color="disabled"
          style={{ marginRight: 5 }}
        />
        <div className={classes.informationLabel}>
          <b>Önemli Bilgilendirme: </b> Veri güvenliğiniz için hassas veya sır
          niteliğinde veri içeren bilgilere Mobil ve İnternet Bankacılığı
          kanallarımıza giriş yaparak ulaşabilir, bankacılık işlemlerinizi
          dilediğiniz yerden, 7 gün 24 saat güvenli bir şekilde
          gerçekleştirebilirsiniz. Finansal verilerinizin görüntülenmesi dahil
          her türlü bankacılık işleminizi Mobil ve İnternet Bankacılığımız
          üzerinden gerçekleştirmeniz güvenliğiniz için kritik öneme sahiptir.
        </div>
      </div>

      {props.processContext?.canSendMailForDocument &&
        props.processContext?.canSendMailForDocument === "1" && (
          <Grid item xs={12}>
            <FormControlLabel
              value="1"
              control={
                <Checkbox
                  checked={sendMailForDocument}
                  onChange={(ev) => setSendMailForDocument(ev.target.checked)}
                  color={"primary"}
                />
              }
              label="Dokümanların onaylı mail adresime gönderilmesini istiyorum."
              classes={{
                label: classes.label,
              }}
            />
          </Grid>
        )}

      {smsSended && time > 0 && (
        <Box style={{ display: "flex", justifyContent: "center" }}>
          {props.global.otpInfo.pushDelivery !== "1" ? (
            <BaseTextField
              value={otpCode}
              autoFocus
              onChange={(ev) => setOtpCode(ev.target.value)}
              InputProps={{
                inputComponent: otpMask,
              }}
              inputProps={{ className: classes.otpInput }}
              style={{ textAlign: "center", width: "50%", fontSize: 20 }}
            />
          ) : (
            <p className={classes.header}>
              {"Kredi başvuru işlemine devam edebilmek için lütfen " +
                props.global.otpInfo?.deviceName +
                " cep telefonunuza " +
                props.global.otpInfo?.otpReference +
                " referans koduyla iletilen bildirimi onaylayınız. Eğer bildirim gelmediyse lütfen Fibabanka Mobil uygulamanızı açınız."}
            </p>
          )}

          <CountDown time={time} />
        </Box>
      )}

      <Grid container item style={{ marginTop: 30 }}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.button}
          onClick={geriClick}
        >
          Geri
        </Button>

        {smsSended && time > 0 ? (
          <>
            {props.global.otpInfo.pushDelivery === "1" && (
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={sendSms}
              >
                Yeniden Gönder
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              disabled={isUsedInProgress}
              onClick={devamClick}
            >
              Fibabanka{" "}
              {getProductTypeString(props.processContext?.productType)} Kredisi
              ile ödemeyi onaylıyorum
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={sendSms}
          >
            {props.global.otpInfo.pushDelivery === "1"
              ? "Doğrula"
              : "Sms Gönder"}
          </Button>
        )}
      </Grid>
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    processContext: state.processContext,
    document: state.document,
    customerInformations: state.customerInformations,
    alert: state.alert,
    global: state.global,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      getDocuments: bindActionCreators(getDocuments, dispatch),
      saveDocuments: bindActionCreators(saveDocuments, dispatch),
      used: bindActionCreators(used, dispatch),
      generateOtpEasycep: bindActionCreators(generateOtpEasycep, dispatch),
      updateUnsuccessMsg: bindActionCreators(updateUnsuccessMsg, dispatch),
      addProcessContext: bindActionCreators(addProcessContext, dispatch),
      clearProcessContext: bindActionCreators(clearProcessContext, dispatch),
      generateOTP: bindActionCreators(generateOTP, dispatch),
      updateAlert: bindActionCreators(updateAlert, dispatch),
      updateLoading: bindActionCreators(updateLoading, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Documents);
